var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ProgressHeader',{attrs:{"tabs":_vm.tabs,"saving-for-exit":_vm.savingForExit,"disable":_vm.disableHeader,"disable-save-and-close":_vm.disableSaveAndClose},on:{"tab:selected":_vm.tabSelected,"exit":_vm.exit,"exit:save":_vm.saveAndClose}})
}
var staticRenderFns = []

export { render, staticRenderFns }